import React from 'react';
import './Home.css';
import backgroundVideo from './images/homevideo2.mp4';

function Home() {
  return (
    <div className="home-container">
      <video autoPlay loop muted className="background-video">
        <source src={backgroundVideo} type="video/mp4" />
        Tu navegador no soporta el elemento de video.
      </video>
      <div className="title-box">
        <h1>
          <i>S</i>MARKETING INTELLIGENCE
        </h1>
      </div>
      <div className="text-box">
        <p>
          La innovación ha sido siempre el eje principal de nuestra actividad, 
          definiendo una línea de actuación muy marcada a la hora del desarrollo 
          de soluciones tecnológicas y estrategias empresariales.
        </p>
      </div>
    </div>
  );
}

export default Home;
